import React, { useState, Dispatch, SetStateAction } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormHelperText,
} from '@mui/material';
import SearchableDropdown from '../shared/components/SearchableDropdown';


interface AddPartitionModalProps {
  studyOptions: SearchableDropdownOption[];
  partitionOptions:  SearchableDropdownOption[];
  open: boolean;
  onClose: () => void;
  onSave: (name: string, study: number) => void;
}

const AddPartitionModal: React.FC<AddPartitionModalProps> = ({ open, onClose, onSave, studyOptions, partitionOptions}) => {
  const [name, setName] = useState('');
  const [study, setStudy] = useState<SearchableDropdownOption[]>([]);
  const [error, setError] = useState<string | null>(null);

  const handleSave = () => {

    if (study.length === 0) {
      setError('Please select a study');
      return;
    }

    let nameCheck = study[0].value + ' - ' + name;

    let allPartitionSet = new Set();
    for (let i = 0; i < partitionOptions.length; i++) {
      allPartitionSet.add(partitionOptions[i].value);
    }

    if (allPartitionSet.has(nameCheck)) {
      setError('Partition name already exists for this study. Please choose a different name.');
      return;
    }

    let studyId = study[0].id
    if (studyId) 
      onSave(name, studyId);
    onClose();
  };

  const handleStudyChange: Dispatch<SetStateAction<SearchableDropdownOption[]>> = (value) => {
    setStudy(value);
    setError(null);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Add Partition</DialogTitle>
      <DialogContent>
        <div style={{ paddingBottom: '10px', paddingTop: '10px' }}>
          <SearchableDropdown
            label="Study"
            value={study}
            setValue={handleStudyChange}
            options={studyOptions}
            placeholder="Study"
            multiple={false}
          />
        </div>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Partition Name"
          type="text"
          fullWidth
          variant="outlined"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
         {error && <FormHelperText error>{error}</FormHelperText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="primary" onClick={handleSave} disabled={study.length === 0 || !name}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPartitionModal;